// noinspection DuplicatedCode
// Auto-generated by `./chore/regenerate-public-wizard.sh`

import { Result, Schema } from "./schema"
import * as builder from "./schemaBuilder"

const facts = builder.makeFacts({
    developingOrProcuring: ["developer", "procureAndUse", "none"],
    euMarket: ["first", "notFirst"],
    euService: ["yes", "no"],
    euAvailable: ["yes", "no"],
    trademarkThirdCountry: ["yes", "no"],
    locatedInEU: ["yes", "no"],
    euUse: ["yes", "no"],
    representation: ["representing", "notRepresenting"],
    personalUse: ["personalOnly", "alsoProfessional"],
    modifications: ["significant", "trademark", "intendedPurpose", "unchanged"],
    purpose: ["scientific", "military", "lawOrJustice"],
    prohibitedSystems: [
        "manipulation",
        "vulnerabilities",
        "socialScoring",
        "predictivePolicing",
        "facialRecognition",
        "emotionRecognition",
        "biometricCategorisation",
        "realTimeRemoteBiometrics",
    ],
    categoriesIB: [
        "civilAviationSecurity",
        "ATV",
        "agriculturalVehicle",
        "motorVehicle",
        "marineEquipment",
        "railSystem",
    ],
    categoriesIA: [
        "machinery",
        "toys",
        "recreationalCrafts",
        "lifts",
        "explosiveAtmospheres",
        "radioEquipment",
        "pressureEquipment",
        "cablewayInstallations",
        "protectiveEquipment",
        "gaseousFuels",
        "medicalDevices",
        "inVitroDiagnostics",
    ],
    thirdPartyAssessment: ["required", "notRequired"],
    categories6III: [
        "biometrics",
        "education",
        "employment",
        "publicServices",
        "lawEnforcement",
        "migration",
        "justice",
        "infrastructure",
    ],
    harmfulHighRisk: ["notHarmful", "mightBeHarmful"],
    usage: [
        "interaction",
        "syntheticContent",
        "deepfake",
        "publicInterest",
        "emotions",
    ],
    publicLaw: ["yesPublicLaw", "noPublicLaw"],
    license: ["foss", "closedSource"],
    gpai: ["yesGpai", "noGpai"],
    gpaiCapabilities: ["high", "notHigh"],
    systemicRisk: ["definitelyNot", "likelyRisk"],
} as const)
const answerIndex = builder.makeAnswerIndex(facts)

const questionEuMarket = builder.subquestionOneAnswer(
    facts.euMarket,
    "euMarket",
    {},
    [
        {
            answer: facts.euMarket.answer.first,
            title: "first",
        },
        {
            answer: facts.euMarket.answer.notFirst,
            title: "notFirst",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(answerIndex.developingOrProcuring.developer),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.developingOrProcuring.procureAndUse,
            ),
        ),
        builder.when.all(
            builder.answers(answerIndex.developingOrProcuring.none),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.developingOrProcuring.none,
            ),
        ),
    ),
)

const questionEuService = builder.subquestionOneAnswer(
    facts.euService,
    "euService",
    {},
    [
        {
            answer: facts.euService.answer.yes,
            title: "yes",
        },
        {
            answer: facts.euService.answer.no,
            title: "no",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.euMarket.notFirst,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
            ),
        ),
    ),
)

const questionEuAvailable = builder.subquestionOneAnswer(
    facts.euAvailable,
    "euAvailable",
    {},
    [
        {
            answer: facts.euAvailable.answer.yes,
            title: "yes",
        },
        {
            answer: facts.euAvailable.answer.no,
            title: "no",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
            ),
        ),
    ),
)

const questionTrademarkThirdCountry = builder.subquestionOneAnswer(
    facts.trademarkThirdCountry,
    "trademarkThirdCountry",
    {},
    [
        {
            answer: facts.trademarkThirdCountry.answer.yes,
            title: "yes",
        },
        {
            answer: facts.trademarkThirdCountry.answer.no,
            title: "no",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
            ),
        ),
    ),
)

const questionLocatedInEU = builder.subquestionOneAnswer(
    facts.locatedInEU,
    "locatedInEU",
    {},
    [
        {
            answer: facts.locatedInEU.answer.yes,
            title: "yes",
        },
        {
            answer: facts.locatedInEU.answer.no,
            title: "no",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
            ),
        ),
        builder.when.all(
            builder.answers(answerIndex.developingOrProcuring.procureAndUse),
        ),
    ),
)

const questionEuUse = builder.subquestionOneAnswer(
    facts.euUse,
    "euUse",
    {},
    [
        {
            answer: facts.euUse.answer.yes,
            title: "yes",
        },
        {
            answer: facts.euUse.answer.no,
            title: "no",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
            ),
        ),
    ),
)

const questionRepresentation = builder.subquestionOneAnswer(
    facts.representation,
    "representation",
    {},
    [
        {
            answer: facts.representation.answer.representing,
            title: "representing",
        },
        {
            answer: facts.representation.answer.notRepresenting,
            title: "notRepresenting",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
            ),
        ),
    ),
)

const questionPersonalUse = builder.subquestionOneAnswer(
    facts.personalUse,
    "personalUse",
    {},
    [
        {
            answer: facts.personalUse.answer.personalOnly,
            title: "personalOnly",
        },
        {
            answer: facts.personalUse.answer.alsoProfessional,
            title: "alsoProfessional",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
            ),
        ),
    ),
)

const questionModifications = builder.subquestionOneAnswer(
    facts.modifications,
    "modifications",
    {},
    [
        {
            answer: facts.modifications.answer.significant,
            title: "significant",
        },
        {
            answer: facts.modifications.answer.trademark,
            title: "trademark",
        },
        {
            answer: facts.modifications.answer.intendedPurpose,
            title: "intendedPurpose",
        },
        {
            answer: facts.modifications.answer.unchanged,
            title: "unchanged",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.euMarket.first,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.personalOnly,
                answerIndex.personalUse.alsoProfessional,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
            ),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.personalOnly,
                answerIndex.personalUse.alsoProfessional,
            ),
        ),
    ),
)

const questionProhibitedSystems = builder.subquestionAnyThatApply(
    facts.prohibitedSystems,
    "prohibitedSystems",
    {},
    [
        {
            answer: facts.prohibitedSystems.answer.manipulation,
            title: "manipulation",
        },
        {
            answer: facts.prohibitedSystems.answer.vulnerabilities,
            title: "vulnerabilities",
        },
        {
            answer: facts.prohibitedSystems.answer.socialScoring,
            title: "socialScoring",
        },
        {
            answer: facts.prohibitedSystems.answer.predictivePolicing,
            title: "predictivePolicing",
        },
        {
            answer: facts.prohibitedSystems.answer.facialRecognition,
            title: "facialRecognition",
        },
        {
            answer: facts.prohibitedSystems.answer.emotionRecognition,
            title: "emotionRecognition",
        },
        {
            answer: facts.prohibitedSystems.answer.biometricCategorisation,
            title: "biometricCategorisation",
        },
        {
            answer: facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            title: "realTimeRemoteBiometrics",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.no,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
        builder.when.all(
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
        ),
    ),
)

const questionCategoriesIB = builder.subquestionAnyThatApply(
    facts.categoriesIB,
    "categoriesIB",
    {},
    [
        {
            answer: facts.categoriesIB.answer.civilAviationSecurity,
            title: "civilAviationSecurity",
        },
        {
            answer: facts.categoriesIB.answer.ATV,
            title: "ATV",
        },
        {
            answer: facts.categoriesIB.answer.agriculturalVehicle,
            title: "agriculturalVehicle",
        },
        {
            answer: facts.categoriesIB.answer.motorVehicle,
            title: "motorVehicle",
        },
        {
            answer: facts.categoriesIB.answer.marineEquipment,
            title: "marineEquipment",
        },
        {
            answer: facts.categoriesIB.answer.railSystem,
            title: "railSystem",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.no,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
    ),
)

const questionCategoriesIA = builder.subquestionAnyThatApply(
    facts.categoriesIA,
    "categoriesIA",
    {},
    [
        {
            answer: facts.categoriesIA.answer.machinery,
            title: "machinery",
        },
        {
            answer: facts.categoriesIA.answer.toys,
            title: "toys",
        },
        {
            answer: facts.categoriesIA.answer.recreationalCrafts,
            title: "recreationalCrafts",
        },
        {
            answer: facts.categoriesIA.answer.lifts,
            title: "lifts",
        },
        {
            answer: facts.categoriesIA.answer.explosiveAtmospheres,
            title: "explosiveAtmospheres",
        },
        {
            answer: facts.categoriesIA.answer.radioEquipment,
            title: "radioEquipment",
        },
        {
            answer: facts.categoriesIA.answer.pressureEquipment,
            title: "pressureEquipment",
        },
        {
            answer: facts.categoriesIA.answer.cablewayInstallations,
            title: "cablewayInstallations",
        },
        {
            answer: facts.categoriesIA.answer.protectiveEquipment,
            title: "protectiveEquipment",
        },
        {
            answer: facts.categoriesIA.answer.gaseousFuels,
            title: "gaseousFuels",
        },
        {
            answer: facts.categoriesIA.answer.medicalDevices,
            title: "medicalDevices",
        },
        {
            answer: facts.categoriesIA.answer.inVitroDiagnostics,
            title: "inVitroDiagnostics",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.no,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
    ),
)

const questionThirdPartyAssessment = builder.subquestionOneAnswer(
    facts.thirdPartyAssessment,
    "thirdPartyAssessment",
    {},
    [
        {
            answer: facts.thirdPartyAssessment.answer.required,
            title: "required",
        },
        {
            answer: facts.thirdPartyAssessment.answer.notRequired,
            title: "notRequired",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.no,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
    ),
)

const questionCategories6III = builder.subquestionAnyThatApply(
    facts.categories6III,
    "categories6III",
    {},
    [
        {
            answer: facts.categories6III.answer.biometrics,
            title: "biometrics",
        },
        {
            answer: facts.categories6III.answer.education,
            title: "education",
        },
        {
            answer: facts.categories6III.answer.employment,
            title: "employment",
        },
        {
            answer: facts.categories6III.answer.publicServices,
            title: "publicServices",
        },
        {
            answer: facts.categories6III.answer.lawEnforcement,
            title: "lawEnforcement",
        },
        {
            answer: facts.categories6III.answer.migration,
            title: "migration",
        },
        {
            answer: facts.categories6III.answer.justice,
            title: "justice",
        },
        {
            answer: facts.categories6III.answer.infrastructure,
            title: "infrastructure",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.no,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.no,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
    ),
)

const questionHarmfulHighRisk = builder.subquestionOneAnswer(
    facts.harmfulHighRisk,
    "harmfulHighRisk",
    {},
    [
        {
            answer: facts.harmfulHighRisk.answer.notHarmful,
            title: "notHarmful",
        },
        {
            answer: facts.harmfulHighRisk.answer.mightBeHarmful,
            title: "mightBeHarmful",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.no,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.no,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
    ),
)

const questionUsage = builder.subquestionAnyThatApply(
    facts.usage,
    "usage",
    {},
    [
        {
            answer: facts.usage.answer.interaction,
            title: "interaction",
        },
        {
            answer: facts.usage.answer.syntheticContent,
            title: "syntheticContent",
        },
        {
            answer: facts.usage.answer.deepfake,
            title: "deepfake",
        },
        {
            answer: facts.usage.answer.publicInterest,
            title: "publicInterest",
        },
        {
            answer: facts.usage.answer.emotions,
            title: "emotions",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.no,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
    ),
)

const questionPublicLaw = builder.subquestionOneAnswer(
    facts.publicLaw,
    "publicLaw",
    {},
    [
        {
            answer: facts.publicLaw.answer.yesPublicLaw,
            title: "yesPublicLaw",
        },
        {
            answer: facts.publicLaw.answer.noPublicLaw,
            title: "noPublicLaw",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.mightBeHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.thirdPartyAssessment.required,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.mightBeHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.thirdPartyAssessment.required,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
        ),
    ),
)

const questionLicense = builder.subquestionOneAnswer(
    facts.license,
    "license",
    {},
    [
        {
            answer: facts.license.answer.foss,
            title: "foss",
        },
        {
            answer: facts.license.answer.closedSource,
            title: "closedSource",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.no,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.unchanged,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
    ),
)

const questionGpai = builder.subquestionOneAnswer(
    facts.gpai,
    "gpai",
    {},
    [
        {
            answer: facts.gpai.answer.yesGpai,
            title: "yesGpai",
        },
        {
            answer: facts.gpai.answer.noGpai,
            title: "noGpai",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.thirdPartyAssessment.notRequired,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.anyAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.harmfulHighRisk.notHarmful,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.anyAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.anyAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
            ]),
        ),
        builder.when.all(
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
            builder.when.noAnswer(facts.categoriesIB.fact, [
                facts.categoriesIB.answer.civilAviationSecurity,
                facts.categoriesIB.answer.ATV,
                facts.categoriesIB.answer.agriculturalVehicle,
                facts.categoriesIB.answer.motorVehicle,
                facts.categoriesIB.answer.marineEquipment,
                facts.categoriesIB.answer.railSystem,
            ]),
            builder.when.noAnswer(facts.categoriesIA.fact, [
                facts.categoriesIA.answer.machinery,
                facts.categoriesIA.answer.toys,
                facts.categoriesIA.answer.recreationalCrafts,
                facts.categoriesIA.answer.lifts,
                facts.categoriesIA.answer.explosiveAtmospheres,
                facts.categoriesIA.answer.radioEquipment,
                facts.categoriesIA.answer.pressureEquipment,
                facts.categoriesIA.answer.cablewayInstallations,
                facts.categoriesIA.answer.protectiveEquipment,
                facts.categoriesIA.answer.gaseousFuels,
                facts.categoriesIA.answer.medicalDevices,
                facts.categoriesIA.answer.inVitroDiagnostics,
            ]),
            builder.when.noAnswer(facts.categories6III.fact, [
                facts.categories6III.answer.biometrics,
                facts.categories6III.answer.education,
                facts.categories6III.answer.employment,
                facts.categories6III.answer.publicServices,
                facts.categories6III.answer.lawEnforcement,
                facts.categories6III.answer.migration,
                facts.categories6III.answer.justice,
                facts.categories6III.answer.infrastructure,
            ]),
            builder.when.noAnswer(facts.usage.fact, [
                facts.usage.answer.interaction,
                facts.usage.answer.syntheticContent,
                facts.usage.answer.deepfake,
                facts.usage.answer.publicInterest,
                facts.usage.answer.emotions,
            ]),
        ),
    ),
)

const questionGpaiCapabilities = builder.subquestionOneAnswer(
    facts.gpaiCapabilities,
    "gpaiCapabilities",
    {},
    [
        {
            answer: facts.gpaiCapabilities.answer.high,
            title: "high",
        },
        {
            answer: facts.gpaiCapabilities.answer.notHigh,
            title: "notHigh",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.gpai.yesGpai,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
    ),
)

const questionSystemicRisk = builder.subquestionOneAnswer(
    facts.systemicRisk,
    "systemicRisk",
    {},
    [
        {
            answer: facts.systemicRisk.answer.definitelyNot,
            title: "definitelyNot",
        },
        {
            answer: facts.systemicRisk.answer.likelyRisk,
            title: "likelyRisk",
        },
    ],

    builder.when.any(
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.first,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.developer,
                answerIndex.euMarket.notFirst,
                answerIndex.euService.yes,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.significant,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.first,
                answerIndex.trademarkThirdCountry.yes,
                answerIndex.modifications.trademark,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.no,
                answerIndex.locatedInEU.yes,
                answerIndex.representation.representing,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.intendedPurpose,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.significant,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.none,
                answerIndex.euMarket.notFirst,
                answerIndex.euAvailable.yes,
                answerIndex.modifications.trademark,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.no,
                answerIndex.euUse.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.intendedPurpose,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.significant,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
        builder.when.all(
            builder.answers(
                answerIndex.developingOrProcuring.procureAndUse,
                answerIndex.locatedInEU.yes,
                answerIndex.personalUse.alsoProfessional,
                answerIndex.modifications.trademark,
                answerIndex.gpai.yesGpai,
                answerIndex.gpaiCapabilities.high,
            ),
            builder.when.noAnswer(facts.purpose.fact, [
                facts.purpose.answer.scientific,
                facts.purpose.answer.military,
                facts.purpose.answer.lawOrJustice,
            ]),
            builder.when.noAnswer(facts.prohibitedSystems.fact, [
                facts.prohibitedSystems.answer.manipulation,
                facts.prohibitedSystems.answer.vulnerabilities,
                facts.prohibitedSystems.answer.socialScoring,
                facts.prohibitedSystems.answer.predictivePolicing,
                facts.prohibitedSystems.answer.facialRecognition,
                facts.prohibitedSystems.answer.emotionRecognition,
                facts.prohibitedSystems.answer.biometricCategorisation,
                facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
            ]),
        ),
    ),
)

const results: Result[] = [
    builder.result(builder.resultId("provider"), {
        title: "provider",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
            ),
        ),
    }),
    builder.result(builder.resultId("out-of-scope-role"), {
        title: "out-of-scope-role",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.no,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.personalOnly,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.personalOnly,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.no,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.no,
                    answerIndex.locatedInEU.no,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.no,
                    answerIndex.locatedInEU.yes,
                    answerIndex.representation.notRepresenting,
                ),
            ),
        ),
    }),
    builder.result(builder.resultId("deployer"), {
        title: "deployer",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
            ),
        ),
    }),
    builder.result(builder.resultId("importer"), {
        title: "importer",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.unchanged,
                ),
            ),
        ),
    }),
    builder.result(builder.resultId("distributor"), {
        title: "distributor",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.no,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.unchanged,
                ),
            ),
        ),
    }),
    builder.result(builder.resultId("authorized-representative"), {
        title: "authorized-representative",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.no,
                    answerIndex.locatedInEU.yes,
                    answerIndex.representation.representing,
                ),
            ),
        ),
    }),
    builder.result(builder.resultId("article-2-excluded"), {
        title: "article-2-excluded",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.no,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.no,
                    answerIndex.locatedInEU.yes,
                    answerIndex.representation.representing,
                ),
                builder.when.anyAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-2-high-risk-exemption"), {
        title: "article-2-high-risk-exemption",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.no,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.no,
                    answerIndex.locatedInEU.yes,
                    answerIndex.representation.representing,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.anyAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-2-10-personal-usage"), {
        title: "article-2-10-personal-usage",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.personalOnly,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.personalOnly,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
            ),
        ),
    }),
    builder.result(builder.resultId("article-2-12-open-source"), {
        title: "article-2-12-open-source",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.no,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.no,
                    answerIndex.locatedInEU.yes,
                    answerIndex.representation.representing,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.license.foss,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-5-prohibited"), {
        title: "article-5-prohibited",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.no,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.no,
                    answerIndex.locatedInEU.yes,
                    answerIndex.representation.representing,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.anyAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-6_3-49_2-6_4"), {
        title: "article-6_3-49_2-6_4",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-16"), {
        title: "article-16",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-22"), {
        title: "article-22",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.no,
                    answerIndex.locatedInEU.yes,
                    answerIndex.representation.representing,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.no,
                    answerIndex.locatedInEU.yes,
                    answerIndex.representation.representing,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-23"), {
        title: "article-23",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-24"), {
        title: "article-24",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.no,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.no,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-25"), {
        title: "article-25",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.euMarket.first,
                    answerIndex.modifications.significant,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.modifications.significant,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.euMarket.first,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.trademark,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.euMarket.first,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.modifications.intendedPurpose,
                ),
            ),
        ),
    }),
    builder.result(builder.resultId("article-26"), {
        title: "article-26",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.required,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-27"), {
        title: "article-27",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.required,
                    answerIndex.publicLaw.yesPublicLaw,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.required,
                    answerIndex.publicLaw.yesPublicLaw,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                    answerIndex.publicLaw.yesPublicLaw,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.mightBeHarmful,
                    answerIndex.publicLaw.yesPublicLaw,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-50-1"), {
        title: "article-50-1",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.notRequired,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                    answerIndex.gpai.noGpai,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-50-2"), {
        title: "article-50-2",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.syntheticContent,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-50-3"), {
        title: "article-50-3",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.emotions,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.emotions,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-50-4"), {
        title: "article-50-4",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.deepfake,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.deepfake,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.deepfake,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.deepfake,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.deepfake,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.deepfake,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.publicInterest,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.publicInterest,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.publicInterest,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.thirdPartyAssessment.notRequired,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.anyAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.publicInterest,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.publicInterest,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                    answerIndex.harmfulHighRisk.notHarmful,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.anyAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.anyAnswer(facts.usage.fact, [
                    facts.usage.answer.publicInterest,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-53"), {
        title: "article-53",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-54"), {
        title: "article-54",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.no,
                    answerIndex.locatedInEU.yes,
                    answerIndex.representation.representing,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.notHigh,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.no,
                    answerIndex.locatedInEU.yes,
                    answerIndex.representation.representing,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.definitelyNot,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-55"), {
        title: "article-55",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                    answerIndex.gpai.yesGpai,
                    answerIndex.gpaiCapabilities.high,
                    answerIndex.systemicRisk.likelyRisk,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("article-4"), {
        title: "article-4",
        when: builder.when.any(
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.first,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.developer,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euService.yes,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.first,
                    answerIndex.trademarkThirdCountry.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.trademark,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.intendedPurpose,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.none,
                    answerIndex.euMarket.notFirst,
                    answerIndex.euAvailable.yes,
                    answerIndex.modifications.significant,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
            builder.when.all(
                builder.answers(
                    answerIndex.developingOrProcuring.procureAndUse,
                    answerIndex.locatedInEU.no,
                    answerIndex.euUse.yes,
                    answerIndex.personalUse.alsoProfessional,
                    answerIndex.modifications.unchanged,
                ),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
            ),
        ),
    }),
    builder.result(builder.resultId("no-system-selected"), {
        title: "no-system-selected",
        when: builder.when.any(
            builder.when.all(
                builder.answers(answerIndex.gpai.noGpai),
                builder.when.noAnswer(facts.purpose.fact, [
                    facts.purpose.answer.scientific,
                    facts.purpose.answer.military,
                    facts.purpose.answer.lawOrJustice,
                ]),
                builder.when.noAnswer(facts.prohibitedSystems.fact, [
                    facts.prohibitedSystems.answer.manipulation,
                    facts.prohibitedSystems.answer.vulnerabilities,
                    facts.prohibitedSystems.answer.socialScoring,
                    facts.prohibitedSystems.answer.predictivePolicing,
                    facts.prohibitedSystems.answer.facialRecognition,
                    facts.prohibitedSystems.answer.emotionRecognition,
                    facts.prohibitedSystems.answer.biometricCategorisation,
                    facts.prohibitedSystems.answer.realTimeRemoteBiometrics,
                ]),
                builder.when.noAnswer(facts.categoriesIB.fact, [
                    facts.categoriesIB.answer.civilAviationSecurity,
                    facts.categoriesIB.answer.ATV,
                    facts.categoriesIB.answer.agriculturalVehicle,
                    facts.categoriesIB.answer.motorVehicle,
                    facts.categoriesIB.answer.marineEquipment,
                    facts.categoriesIB.answer.railSystem,
                ]),
                builder.when.noAnswer(facts.categoriesIA.fact, [
                    facts.categoriesIA.answer.machinery,
                    facts.categoriesIA.answer.toys,
                    facts.categoriesIA.answer.recreationalCrafts,
                    facts.categoriesIA.answer.lifts,
                    facts.categoriesIA.answer.explosiveAtmospheres,
                    facts.categoriesIA.answer.radioEquipment,
                    facts.categoriesIA.answer.pressureEquipment,
                    facts.categoriesIA.answer.cablewayInstallations,
                    facts.categoriesIA.answer.protectiveEquipment,
                    facts.categoriesIA.answer.gaseousFuels,
                    facts.categoriesIA.answer.medicalDevices,
                    facts.categoriesIA.answer.inVitroDiagnostics,
                ]),
                builder.when.noAnswer(facts.categories6III.fact, [
                    facts.categories6III.answer.biometrics,
                    facts.categories6III.answer.education,
                    facts.categories6III.answer.employment,
                    facts.categories6III.answer.publicServices,
                    facts.categories6III.answer.lawEnforcement,
                    facts.categories6III.answer.migration,
                    facts.categories6III.answer.justice,
                    facts.categories6III.answer.infrastructure,
                ]),
                builder.when.noAnswer(facts.usage.fact, [
                    facts.usage.answer.interaction,
                    facts.usage.answer.syntheticContent,
                    facts.usage.answer.deepfake,
                    facts.usage.answer.publicInterest,
                    facts.usage.answer.emotions,
                ]),
            ),
        ),
    }),
]

const questionDevelopingOrProcuring = builder.oneAnswerQuestion(
    facts.developingOrProcuring,
    "developingOrProcuring",
    {},
    [
        {
            answer: facts.developingOrProcuring.answer.developer,
            title: "developer",
        },
        {
            answer: facts.developingOrProcuring.answer.procureAndUse,
            title: "procureAndUse",
        },
        {
            answer: facts.developingOrProcuring.answer.none,
            title: "none",
        },
    ],
    [
        questionEuMarket,
        questionEuService,
        questionEuAvailable,
        questionTrademarkThirdCountry,
        questionLocatedInEU,
        questionEuUse,
        questionRepresentation,
        questionPersonalUse,
        questionModifications,
    ],
)

const questionPurpose = builder.anyThatApplyQuestion(
    facts.purpose,
    "purpose",
    {},
    [
        {
            answer: facts.purpose.answer.scientific,
            title: "scientific",
        },
        {
            answer: facts.purpose.answer.military,
            title: "military",
        },
        {
            answer: facts.purpose.answer.lawOrJustice,
            title: "lawOrJustice",
        },
    ],
    [
        questionProhibitedSystems,
        questionCategoriesIB,
        questionCategoriesIA,
        questionThirdPartyAssessment,
        questionCategories6III,
        questionHarmfulHighRisk,
        questionUsage,
        questionPublicLaw,
        questionLicense,
        questionGpai,
        questionGpaiCapabilities,
        questionSystemicRisk,
    ],
)

const schema: Schema = {
    questions: [questionDevelopingOrProcuring, questionPurpose],
    results,
}
export default schema
